import {
    buildBulkUserJobRequestId,
    getBulkUserJobStatus,
    pollBulkUserJobStatus,
} from './users-bulk-user-job-poll.utils';

export {
    DEFAULT_POLL_INTERVAL_MS,
    DEFAULT_POLL_MAX_ATTEMPTS,
} from './users-bulk-user-job-poll.utils';

const BULK_DELETE_ENDPOINT = '/api/s/_SID_/user/bulk/v2/removeUserFromSubscription';
const REQUEST_ID_SUFFIX = 'bulk-delete-user';
const OPERATION_LABEL = 'Bulk delete';

export function buildBulkDeleteRequestId ({ subscriptionId, userId }) {
    return buildBulkUserJobRequestId({ subscriptionId, userId, suffix: REQUEST_ID_SUFFIX });
}

export function getBulkDeleteStatus (requestId) {
    return getBulkUserJobStatus({ endpoint: BULK_DELETE_ENDPOINT, requestId });
}

export function pollBulkDeleteStatus (opts = {}) {
    return pollBulkUserJobStatus({
        endpoint: BULK_DELETE_ENDPOINT,
        operationLabel: OPERATION_LABEL,
        ...opts,
    });
}
